import { render, staticRenderFns } from "./onboardingPage.vue?vue&type=template&id=d94358e4&scoped=true"
import script from "./onboardingPage.vue?vue&type=script&lang=js"
export * from "./onboardingPage.vue?vue&type=script&lang=js"
import style0 from "./onboardingPage.vue?vue&type=style&index=0&id=d94358e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94358e4",
  null
  
)

export default component.exports